import { createContext } from "react";

const Context = createContext();
Context.displayName = "KeyLockerContext";

export default Context;
